module.exports = __webpack_public_path__ + "static/media/md-square.fa10cfed.svg";